var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolderLock24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18.91,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.18 2.18H11.42L9.24 0H1.82A1.83 1.83 0 000 1.82v15.27a1.82 1.82 0 001.82 1.82h20.36A1.82 1.82 0 0024 17.09V4a1.83 1.83 0 00-1.82-1.82z",
    fill: "#c92467"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.739 8.967v-.822a2.739 2.739 0 10-5.472 0v.822a1.533 1.533 0 00-1.506 1.526v3.613a1.533 1.533 0 001.533 1.533h5.42a1.533 1.533 0 001.526-1.533v-3.613a1.526 1.526 0 00-1.5-1.526zm-4.22 0v-.822a1.441 1.441 0 011.475-1.539 1.461 1.461 0 011.487 1.539v.822zm-1.5 1.526a.274.274 0 01.274-.274h5.42a.274.274 0 01.274.274v3.613a.274.274 0 01-.274.28H9.294a.274.274 0 01-.274-.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.374 13.205a.652.652 0 001.252 0v-.828a.926.926 0 10-1.252 0z"
  }))));
}
export default SvgIconFolderLock24;